export default __webpack_public_path__ + "static/media/appointments_7.e778f8cf.jpg";